import RouteConst from 'constants/RouteConst'
import SessionConst from 'constants/SessionConst'
import SideNavConst from 'constants/SideNavConst'
import React, { Component } from 'react'
import { FaBed, FaCheckCircle, FaDollarSign, FaExclamationCircle, FaFileAlt, FaHome } from 'react-icons/fa'
import { NavLink, withRouter } from 'react-router-dom'
import {isFormEnabled, isScandinavianProperty} from 'utilities/FormHelper'
import {hideSrpInventoryPage, isObjectEmpty, isRadissonProperty, searchFirstObjectInList} from 'utilities/JSUtil'
import { getSessionItem } from 'utilities/SessionHelper'
import './SideNav.scss'
import RoomTypeBucketsService from "../../../services/RoomTypeBucketsService";
import RoomTypesService from "../../../services/RoomTypesService";
import * as FormConst from '../../../constants/FormConst'

class SideNav extends Component {

  constructor(props) {
    super(props)
    const user = getSessionItem(SessionConst.USER)
    const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
    const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
    const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
    const hideSrpInventory = hideSrpInventoryPage(hotelInfoCompletedHistory, this.props.checklist, hotelInfo.brandCode);


    if (!user || isObjectEmpty(user)) {
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    const isHotelContact = user.isHotelContact

    this.state = {
      isHotelContact: isHotelContact,
      hotelCode: hotelCode,
      hotelInfo: hotelInfo,
      hideSrpInventory: hideSrpInventory,
      isRadissonProperty: isRadissonProperty(hotelInfo.brandCode)
    }
  }

  getIcon(iconName) {
    switch (iconName) {
      case 'home':
        return <FaHome />
      case 'bed':
        return <FaBed />
      case 'dollar':
        return <FaDollarSign />
      case 'flag':
        return <FaFileAlt />
    }
  }

  render() {
    let sideNavEntries = []
    let isRoomTypesCompleted = false
    const hotelBrandCode = this.state.hotelInfo.brandCode;
    const availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];

    // Build the side nav entry list
    SideNavConst.ENTRY_LIST.map(section => {
      const icon = this.getIcon(section.icon)

      if (section.sectionTitle === 'Submit' && !this.state.isHotelContact) {
        // Need to check if submit is required for other roles
      } else {
        sideNavEntries.push(
          <div key={section.icon}>
            <ul>
              <li className='list-item-header'>
                {icon}
                  &nbsp;
                  <span className='side-nav-header-text'>{section.sectionTitle}</span>
              </li>
              {section.data.map((entry) => {
                let isComplete = false
                let isError = false

                switch (entry.name) {
                  case 'HOTEL_POLICIES':
                    const petPoliciesObject = searchFirstObjectInList('code', 'HOTEL_PET_POLICIES', this.props.checklist)
                    const groupPoliciesObject = searchFirstObjectInList('code', 'GROUP_POLICIES', this.props.checklist)
                    const guaranteeCancelPoliciesObject = searchFirstObjectInList('code', 'GUARANTEE_CANCEL_POLICES', this.props.checklist)
                    const ageTiersObject = searchFirstObjectInList('code', 'AGE_TIERS', this.props.checklist)

                    const isAE = this.state.hotelInfo.brandCode === 'AE'
                    let arrPoliciesObjects = [petPoliciesObject, guaranteeCancelPoliciesObject]
                    if (!isAE) {
                        arrPoliciesObjects.push(groupPoliciesObject)
                    }
                    if (isScandinavianProperty(this.state.hotelInfo)) {
                        arrPoliciesObjects.push(ageTiersObject)
                    }
                    const validatePoliciesResult = this.validatePolicies(arrPoliciesObjects,
                                                        isError,
                                                        isComplete);
                    isError = validatePoliciesResult.isError;
                    isComplete = validatePoliciesResult.isComplete;
                    break;
                  case 'ROOM_TYPES':
                    const result = this.defaultValidationRenderForNav(entry, isError, isComplete);
                    if(this.state.isRadissonProperty) {
                      isError = result.isError
                      isComplete = this.allRoomTypesHasBeenAssignedToBucket(this.state.hotelCode) && result.isComplete
                    } else {
                      isError = result.isError;
                      isComplete = result.isComplete;
                    }
                    isRoomTypesCompleted = isComplete
                    break;
                  case 'RATE_PLANS':
                    const boxInventoryObject = searchFirstObjectInList('code', 'BOX_INVENTORY', this.props.checklist)
                    const ratePlansObject = searchFirstObjectInList('code', 'RATE_PLANS', this.props.checklist)
                    const srpInventoryObject = searchFirstObjectInList('code', 'SRP_INVENTORY', this.props.checklist)
                    const otaRateProgramsObject = searchFirstObjectInList('code', 'OTA_RATE_PROGRAMS', this.props.checklist)
                    const blackoutsObject = searchFirstObjectInList('code', 'BLACK_OUTS', this.props.checklist)
                    const isCompletedSrpInventory = this.state.hideSrpInventory ? true : srpInventoryObject?.processedFlag === 'COMPLETED'

                    if (boxInventoryObject?.errorState || ratePlansObject?.errorState || otaRateProgramsObject?.errorState || blackoutsObject?.errorState) {
                      isError = true
                    } else if (boxInventoryObject?.processedFlag === 'COMPLETED' && ratePlansObject?.processedFlag === 'COMPLETED' &&
                      otaRateProgramsObject?.processedFlag === 'COMPLETED' && blackoutsObject?.processedFlag === 'COMPLETED' && isCompletedSrpInventory && isRoomTypesCompleted) {
                      isComplete = true
                    }
                    break;
                  case 'HOTEL_CONTENT':
                    if(availableHotelContent === undefined || (availableHotelContent !== undefined && !availableHotelContent.includes(FormConst.WEDDING_CONTENT_CODE))) {
                      return;
                    }
                    const hotelContentObject = searchFirstObjectInList('code', 'HOTEL_CONTENT', this.props.checklist)
                    if(hotelContentObject?.processedFlag === 'COMPLETED') {
                      isComplete = true
                    }
                    break;
                  default:
                    const defaultResult = this.defaultValidationRenderForNav(entry, isError, isComplete);
                    isError = defaultResult.isError;
                    isComplete = defaultResult.isComplete;
                }

                let listItemClasses = []
                if (entry.current.id === this.props.selectedFormId) {
                  listItemClasses.push('list-item-selected')
                }

                if (isFormEnabled(entry, this.props.checklist)) {
                  listItemClasses.push('list-item-enabled')
                } else {
                  listItemClasses.push('list-item-disabled')
                }

                // if (isComplete) {
                //   listItemClasses.push('list-item-complete')
                // }

                return (

                  <li key={entry.current.id} className={listItemClasses.join(' ')}>
                    <div className='side-nav-item'>
                      <NavLink to={entry.current.route}>{entry.current.title}</NavLink>
                      {isComplete && <FaCheckCircle className='list-item-icon' />}
                      {isError && <FaExclamationCircle className='list-item-icon' />}
                    </div>
                  </li>

                )
              })}
            </ul>
          </div>
        )
      }

    })

    return (
      <div id='side-nav' className='side-nav'>
        {sideNavEntries}
      </div>
    )
  }

  validatePolicies(arrPoliciesObjects,
                   isError,
                   isComplete) {


    for(let policyObject of arrPoliciesObjects) {
      if(policyObject?.errorState) {
        isError = true
        break;
      }
    }

    if(!isError) {
      let allCompleted = true;
      for(let policyObject of arrPoliciesObjects) {
        if(policyObject?.processedFlag !== 'COMPLETED') {
          allCompleted = false;
          break;
        }
      }
      isComplete = allCompleted;
    }
    return {isError, isComplete};
  }

  defaultValidationRenderForNav(entry, isError, isComplete) {
    const checklistObject = searchFirstObjectInList('code', entry.name, this.props.checklist)
    if (checklistObject) {
      if (checklistObject.errorState) {
        isError = true
      } else if (checklistObject.processedFlag === 'COMPLETED') {
        isComplete = true
      }
    }
    return {isError, isComplete};
  }

  async allRoomTypesHasBeenAssignedToBucket(hotelCode) {
    let existingRoomTypeBuckets = []
    let assignedRoomTypes = []
    let roomTypes = []
    let availableRoomTypes = []

    await RoomTypeBucketsService.getRoomTypesBuckets({ hotelCode: hotelCode }).then(async (response) => {
      existingRoomTypeBuckets = response.roomTypeBuckets
      existingRoomTypeBuckets.map(bucket => {
        bucket.roomTypes.map(roomType => { assignedRoomTypes.push(roomType)} )
      })
    }).catch(error => {
      this.setState({
                      isLoading: false,
                      showErrorModal: true,
                      errorMessage: 'There was an error while retrieving Hotel Room Type Buckets data'
                    })
    })

    // retrieve hotel room type buckets
    await RoomTypesService.getRoomTypes({hotelCode: hotelCode})
        .then(async (response) => {
          roomTypes = response.roomTypes
          availableRoomTypes = roomTypes.filter( roomType => !assignedRoomTypes.includes(roomType.hotelRoomTypeCode))

        }).catch(error => {
          this.setState({
                          isLoading: false,
                          showErrorModal: true,
                          errorMessage: 'There was an error while retrieving Hotel Room Types data'
                        })
        })
    return availableRoomTypes.length === 0
  }
}

export default withRouter(SideNav)
